import { ITransferStatusResponse } from '../../../modules/admin/types/adminSerffStatus.interface';
import { ADMIN_SERFF_TRANSFER_STATUS_ACTION_TYPES } from '../../../constants/actionTypes/adminSerffStatusActionTypes';

interface IAction {
    type: string;
    payload?: any;
}

export const INITIAL_STATE = {
    serffTransferStatusData: {
        content: [],
        pageable: {
            pageNumber: 0,
            pageSize: 10,
            sort: {
                sorted: false,
                unsorted: true,
                empty: true,
            },
            offset: 0,
            paged: true,
            unpaged: false,
        },
        totalPages: 0,
        totalElements: 0,
        last: false,
        numberOfElements: 0,
        size: 10,
        number: 0,
        sort: {
            sorted: false,
            unsorted: true,
            empty: true,
        },
        first: true,
        empty: true,
    },
    selectedFilters: {
        issuerFilter: '',
        statusFilter: '',
        dateFilter: '',
    },
};


export default (state = INITIAL_STATE, action: IAction) => {
    switch (action?.type) {
        case ADMIN_SERFF_TRANSFER_STATUS_ACTION_TYPES.SET_TRANSFER_STATUS_DATA: {
            return {
                ...state,
                serffTransferStatusData: action.payload as ITransferStatusResponse,
            };
        }
        case ADMIN_SERFF_TRANSFER_STATUS_ACTION_TYPES.SET_TRANSFER_FILTERS: {
            return {
                ...state,
                selectedFilters: action.payload,
            };
        }
        default:
            return state;
    }
};
